// @flow
import * as Sentry from '@sentry/react';
import * as React from 'react';

import type { TProps } from './types';
import { EVENT_TYPES } from '../HOCs/withEventManager';
import Container from '../components/Container';
import PlaidLink, { PlaidEvents } from '../components/PlaidLink';
import type { TPlaidEvents, TPlaidLinkSuccessPayload } from '../components/PlaidLink';
import LoaderOverlay from '../components/LoaderOverlay';

function Plaid(props: TProps): React.Node {
  const [isLoading, setIsLoading] = React.useState(false);

  const onSuccess = (payload: TPlaidLinkSuccessPayload) => {
    const should_verify_accounts = payload
      .accounts
      .some((plaid_account) => (
        !plaid_account.is_ach() && !plaid_account.is_student_loan()
      ));

    if (should_verify_accounts) {
      const verifiable_accounts = payload.accounts.map(plaid_account => plaid_account.to_verifiable_account());

      const merchant = props.merchants.list.find(x => x.provider_ids.plaid.includes(payload.institution.institution_id));
      props.navigateTo('/intro', {
        success_next_path: '/verify-accounts',
        success_next_path_state: {
          public_plaid_account_token: payload.public_token,
          accounts: verifiable_accounts,
          merchant,
        },
      });
    } else {
      setIsLoading(true);
      props.asyncLinkPlaidAccount({
        public_plaid_account_token: payload.public_token,
        accounts: payload.account_id
          ? [{ account_id: payload.account_id, account_number: null }]
          : payload.accounts.map((account) => ({ account_id: account.id, account_number: null })),
      })
      .then((data) => {
        props.dispatchEvent(
          EVENT_TYPES.success,
          data,
          () => props.dispatchEvent(EVENT_TYPES.exit, {}, props.async_delete_link_token),
        );
      })
      .catch((error) => props.dispatchEvent(EVENT_TYPES.error, error.toObject()))
      .finally(() => setIsLoading(false));
    }
  };

  const onEvent = (event: TPlaidEvents, payload: any) => {
    switch (event) {
      case PlaidEvents.exit: props.dispatchEvent(EVENT_TYPES.exit, {}); break;
      case PlaidEvents.error: props.dispatchEvent(EVENT_TYPES.error, {
        type: 'AGGREGATOR_ERROR',
        sub_type: ['PLAID', payload.error_type, payload.error_code].join(':'),
        message: payload.error_message,
      }); break;
      default:
    }
  }

  // $FlowFixMe
  const token: string = props.config.aggregator_options.link_token;
  return (
    <Container height="100vh" width="100vw">
      <LoaderOverlay animationEnabled isLoading={isLoading}>
        <PlaidLink
          token={token}
          onEvent={onEvent}
          onSuccess={onSuccess} />
      </LoaderOverlay>
    </Container>
  );
}

// $FlowFixMe
export default Sentry.withProfiler(Plaid, { name: 'Plaid' });


